class Storage {
  static KEYS = {
    AUTH_TOKEN: 'AUTH_TOKEN',
    PATIENT_AUTH_TOKEN:'PATIENT_AUTH_TOKEN',
    USER: 'USER',
    USER_TYPE: 'USER_TYPE',
  };

  static setItem = (key: string, value: any): void => {
    if (!value) {
      value = '';
    }
    if (typeof value !== 'string') {
      value = JSON.stringify(value);
    }
    localStorage.setItem(key, value);
  };

  static getItem = (key: string, shouldParse?: boolean): string | null => {
    const keyVal = localStorage.getItem(key);
    if (shouldParse && keyVal) {
      return JSON.parse(keyVal);
    }
    return keyVal;
  };

  static removeItem = (key: string): void => {
    localStorage.removeItem(key);
  };

  static removeSessionItem = (key: string): void => {
    sessionStorage.removeItem(key);
  };
}

export default Storage;
